import React, { useState } from 'react';
import {
  Typography,
  Box,
  InputBase,
  useMediaQuery
} from '@mui/material';
import { styled,  } from '@mui/system';
import { theme } from './utils/theme'

function TabPanel(prop) {
  const { children, value, index, ...other } = prop;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: '#ededf7',
  '&:hover': {
    backgroundColor: '#e0f7fa',
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('xs')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));


const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));


const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    // transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const Header = ({setCurrentPage, setSelectedProduct}) => {
  const [value, setValue] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm', {noSsr: true}));

  const navItems = [
      { label: 'Home', page: 'home' },
      { label: 'About', page: 'about' },
      { label: 'FAQs', page: 'faqs' },
      { label: 'Contact', page: 'contact' },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNavClick = (page) => {
      setCurrentPage(page);
      setSelectedProduct(null);
      setMobileOpen(false);
      window.scrollTo(0, 0);
  };

  const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
  };


  return (
    <Box>
        {/* <AppBar position="static" sx={{ backgroundColor: '#f7f7fe' }}>
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Dashboard" {...a11yProps(0)} />
            <Tab label="Getting Started" {...a11yProps(1)} />
            <Tab label="Updates" {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Typography>Dashboard</Typography>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography>Dashboard</Typography>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Typography>Dashboard</Typography>
        </TabPanel> */}
        
        {/* <div className="wrapper">
        {children}
        </div> */}
      </Box>
  );
};

export default Header;
